import { GlobalAxios } from "../axios/axios-config";
import { IScale } from "../models/scale";

const SCALE_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/Scale";

export const scaleList = (params?: any) => {
  return GlobalAxios.get<IScale[]>(SCALE_ROUTE, {
    params,
  });
};
